import axiosClient from './axiosClient';
import {
  IParamsGetJobs,
  IResponseGetJob,
  IResponseGetJobDetail,
  IPayloadDeleteJobs,
  IEditJobPayload,
  IResponseGetJobSelection,
  IResponseGetFiles,
  IJobFileCreate,
  IPayloadDeleteJobsFile,
  IParamsGetJobsBoard,
  IResponseGetJobsBoard,
  IUpdateJobPayload,
  IResponseGetNote,
  IResponseGetTemplate,
  IParamsTemplate,
  ICreateReportFile,
  IParamsGetJobsTimeline,
  IResponseGetJobsTimeline,
  IParamsGetJobExport,
} from '~/utils/interface/job';
import { IApiBaseResponse } from '~/utils/interface/common';
import { IParamsGetNotes, IPayloadDeleteNotes } from '~/utils/interface/note';
import { IEditNote } from '~/utils/interface/note';
import { appendToFormData } from '~/utils/helper';
import { IJobFolderCreate, IResponseGetFolders } from '~/utils/interface/folder';

const jobApi = {
  getJobs(params: IParamsGetJobs) {
    const url = `api/admin/jobs`;
    return axiosClient.get<IApiBaseResponse<IResponseGetJob>>(url, { params });
  },
  getJobsBoard(params: IParamsGetJobsBoard) {
    const url = `api/admin/jobs/board`;
    return axiosClient.get<IApiBaseResponse<IResponseGetJobsBoard>>(url, { params });
  },
  getJobsTimeline(params: IParamsGetJobsTimeline) {
    const url = `api/admin/jobs/timeline`;
    return axiosClient.get<IApiBaseResponse<IResponseGetJobsTimeline>>(url, { params });
  },
  getJob(id: string) {
    return axiosClient.get<IApiBaseResponse<IResponseGetJobDetail>>(`api/admin/jobs/${id}`);
  },
  create(data: IEditJobPayload) {
    const formData = new FormData();
    appendToFormData(formData, data, '', ['logo']);
    return axiosClient.post<IApiBaseResponse<IResponseGetJobDetail>>(`api/admin/jobs/create-by-web`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  updateJob(id: number, data: IUpdateJobPayload) {
    return axiosClient.post<IApiBaseResponse<IResponseGetJobDetail>>(`api/admin/jobs/${id}`, data);
  },
  updateJobAll(id: number, data: IEditJobPayload) {
    return axiosClient.put<IApiBaseResponse<IResponseGetJobDetail>>(`api/admin/jobs/${id}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  deleteJobs(data: IPayloadDeleteJobs) {
    const url = `api/admin/jobs`;
    return axiosClient.delete<IApiBaseResponse<null>>(url, { data });
  },
  deleteJobCustomer(id: number, data: IPayloadDeleteJobs) {
    return axiosClient.delete<IApiBaseResponse<null>>(`api/admin/jobs/${id}/customers`, { data });
  },
  getJobsSelection(type?: string) {
    const url = `api/admin/jobs/selection`;
    return axiosClient.get<IApiBaseResponse<IResponseGetJobSelection>>(url, { params: { type } });
  },
  getFiles(id: string | undefined, params: IJobFileCreate) {
    return axiosClient.get<IApiBaseResponse<IResponseGetFiles>>(`api/admin/jobs/${id}/files`, { params });
  },
  createFiles(id: string | undefined, data: FormData) {
    return axiosClient.post<IApiBaseResponse<null>>(`api/admin/jobs/${id}/files`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  createUploadFiles(id: string | undefined, data: FormData) {
    return axiosClient.post<IApiBaseResponse<null>>(`api/admin/jobs/${id}/uploadFiles`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  deleteFiles(id: string | undefined, data: IPayloadDeleteJobsFile) {
    return axiosClient.delete<IApiBaseResponse<null>>(`api/admin/jobs/${id}/files`, { data });
  },

  createReportFiles(id: string, data: ICreateReportFile) {
    const formData = new FormData();
    appendToFormData(formData, data, '', ['file']);
    return axiosClient.post<IApiBaseResponse<null>>(`api/admin/jobs/${id}/report-files`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  getNotes(params: IParamsGetNotes) {
    return axiosClient.get<IApiBaseResponse<IResponseGetNote>>(`api/admin/notes`, { params });
  },
  createNotes(data: IEditNote) {
    const formData = new FormData();
    appendToFormData(formData, data, '', ['files']);
    return axiosClient.post<IApiBaseResponse<null>>(`api/admin/notes`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  deleteNotes(data: IPayloadDeleteNotes) {
    const url = `api/admin/notes`;
    return axiosClient.delete<IApiBaseResponse<null>>(url, { data });
  },
  updateNotes(id: string | number, data: IEditNote) {
    return axiosClient.put<IApiBaseResponse<IResponseGetNote>>(`api/admin/notes/${id}`, data);
  },
  getTemplate(params: IParamsTemplate) {
    const url = `api/admin/templates`;
    return axiosClient.get<IApiBaseResponse<IResponseGetTemplate>>(url, { params });
  },
  getFolders(id: string | undefined, params: IJobFolderCreate) {
    return axiosClient.get<IApiBaseResponse<IResponseGetFolders>>(`api/admin/jobs/${id}/folders`, { params });
  },
  export(params: IParamsGetJobExport) {
    return axiosClient.get<IApiBaseResponse<null>>(`api/admin/jobs/export`, { params });
  },
  exportMoisturePoints(params: { jobId: string }) {
    return axiosClient.get<IApiBaseResponse<null>>(`api/admin/jobs/export-moisture-points`, { params });
  },
  exportAtmospherics(params: { jobId: string }) {
    return axiosClient.get<IApiBaseResponse<null>>(`api/admin/jobs/export-atmospherics`, { params });
  },
};

export default jobApi;
